import { createClientSharedComposable, getStore } from '@global-store/store'
import { useToastsStore } from '@global-store/stores/toast'
import type { CartStore } from '@shared/global-store/stores/cart/types'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { useLocationStore } from '@shared/global-store/stores/location/location'
import type { Cart } from '@shared/shop-api/cart/types'
import { defineStore } from 'pinia'

export const useCartStore = createClientSharedComposable(() =>
  defineStore('cart', {
    state: (): CartStore => ({
      cart: null,
      isProcessing: false,
    }),

    getters: {
      checkoutUrlWithAuthAndTracking: (state) => {
        const customerStore = useCustomerStore()
        const { urlPrefix } = useLocationStore()

        const checkoutUrl = state?.cart?.checkoutUrl
        if (!checkoutUrl) {
          return undefined
        }
        const url = new URL(checkoutUrl)

        if (urlPrefix?.urlPrefix) {
          url.searchParams.set('locale', urlPrefix.urlPrefix)
        }

        if (customerStore.isAuthenticated) {
          url.searchParams.append('logged_in', 'true')
        }

        if (state?.kickbiteId) {
          url.searchParams.append('kbuid', state.kickbiteId)
        }

        return url.toString()
      },
    },

    actions: {
      setCart(cart?: Cart) {
        const toastStore = useToastsStore()

        this.cart = cart || null

        for (const error of cart?.errors || []) {
          toastStore.addErrorToast(error.message)
        }
      },

      setIsProcessing(isProcessing: boolean) {
        this.isProcessing = isProcessing
      },

      setKickbiteId(kickbiteId?: string) {
        this.kickbiteId = kickbiteId
      },

      $reset() {
        this.cart = null
      },
    },
  })(getStore())
)
